module.exports = __webpack_public_path__ + "img/programme.367d8f7b.png";